import { Ionicons, MaterialIcons } from "@expo/vector-icons";
import { Picker } from "@react-native-picker/picker";
import { useTheme } from "@react-navigation/native";
import * as DocumentPicker from "expo-document-picker";
import * as FileSystem from "expo-file-system";
import {
	Actionsheet,
	Button,
	FormControl,
	Icon,
	IconButton,
	Input,
	Select,
	Stack,
	Text,
	useDisclose,
	useMediaQuery,
} from "native-base";
import React, { useEffect, useState } from "react";
import { Dimensions, Platform, View } from "react-native";
import { BarPasswordStrengthDisplay } from "react-native-password-strength-meter";
import attachFiles from "../../common/attachFiles";
import checkAccountExists from "../../common/checkAccountExists";
import profileSetup from "../../common/profileSetup";
// API.
import registerAccount from "../../common/registerAccount";
import AppCamera from "../../components/camera/AppCamera";
import ErrorToast from "../../components/ErrorToast";
import HeaderText from "../../components/HeaderText";
import InfoToast from "../../components/InfoToast";
import LoadingIndicator from "../../components/LoadingIndicator";
import SuccessToast from "../../components/SuccessToast";
import { isWeb } from "../../utils/utils";
import AlertDialog from "./AlertDialog";
import Summary from "./Summary";

const { width, height } = Dimensions.get("window");

const MemberRegistration = ({
	attrs,
	setIsFormValid,
	setUserDetails,
	UserDetails,
	navigation,
}) => {
	const [validated, setValidated] = useState(false);
	const [state, setState] = useState({});
	const [errors, setErrors] = React.useState({});
	const [showFilter, setShowFilter] = useState(false);
	const [showPopover, setShowPopover] = useState(false);
	const [channel, setChannel] = useState("");
	const [regional, setRegional] = useState("");
	const [isSubmitting, setIsSubmitting] = useState(false);

	const isDesktopOrLaptop = useMediaQuery({ minWidth: 960 });
	const { colors } = useTheme();

	const { isOpen, onOpen, onClose } = useDisclose();

	const onChange = (value, label = null) => {
		if (value.target?.files) {
			setUserDetails({
				...UserDetails,
				[value.target.name]: value.target.files[0],
			});
		} else if (label == "Store" || label == "Role" || label == "Gender") {
			const description = value; // TODO: FIND

			setUserDetails({
				...UserDetails,
				[label]: { value, description },
			});
		} else {
			setUserDetails({
				...UserDetails,
				[label]: value,
			});
		}
	};

	const onChannelChange = (value) => {
		setChannel(value);
	};

	const onRegionalChange = (value) => {
		setRegional(value);
	};

	const Validate = () => {
		let Errors = [];
		if (!UserDetails["Role"]) {
			Errors = {
				...Errors,
				["Role"]: "Please provide Role",
			};
		}
		if (!UserDetails["Store"]) {
			Errors = {
				...Errors,
				["Store"]: "Please provide Store",
			};
		} else if (UserDetails["Store"]?.value === "") {
			Errors = {
				...Errors,
				["Store"]: "Please provide Store",
			};
		}
		if (!UserDetails["Confirm Password"]) {
			Errors = {
				...Errors,
				["Confirm Password"]: "Please Confirm Password",
			};
		}
		if (!UserDetails["Password"]) {
			Errors = {
				...Errors,
				["Password"]: "Please provide Password",
			};
		}
		if (UserDetails["Password"] !== UserDetails["Confirm Password"]) {
			Errors = {
				...Errors,
				["Passwords"]: "Passwords do not match",
			};
		}
		if (!UserDetails["Email Address"]) {
			Errors = {
				...Errors,
				["Email Address"]: "Please provide Email Address",
			};
		} else {
			let mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
			if (!UserDetails["Email Address"].match(mailformat)) {
				Errors = {
					...Errors,
					["Email Address"]: "Please provide a valid email address",
				};
			}
		}

		if (!UserDetails["ID/Passport Document"]) {
			Errors = {
				...Errors,
				["ID/Passport Document"]: "Please provide ID/Passport Document",
			};
		}
		if (!UserDetails["ID/Passport Number"]) {
			Errors = {
				...Errors,
				["ID/Passport Number"]: "Please provide ID/Passport Number",
			};
		}
		if (!UserDetails["Cellphone Number"]) {
			Errors = {
				...Errors,
				["Cellphone Number"]: "Please provide Cellphone Number",
			};
		} else {
			let CellphoneFormat = /^\d{11}$/;
			if (!UserDetails["Cellphone Number"].match(CellphoneFormat)) {
				Errors = {
					...Errors,
					["Cellphone Number"]:
						"Please enter in international format Cellphone Number (e.g. 27xxxxxxxxx)",
				};
			}
		}

		if (!UserDetails["Gender"]) {
			Errors = {
				...Errors,
				["Gender"]: "Please provide Gender",
			};
		}

		if (!UserDetails["Last Name"]) {
			Errors = {
				...Errors,
				["Last Name"]: "Please provide Last Name",
			};
		}

		if (!UserDetails["First Name"]) {
			Errors = {
				["First Name"]: "Please provide First Name",
			};
		}

		if (Object.keys(Errors).length > 0) {
			Object.keys(Errors).map((key, index) => {
				ErrorToast(Errors[key], "Validation Error");
			});
			return false;
		} else {
			return true;
		}
	};

	const [Attributes, setAttributes] = useState([]);

	useEffect(() => {
		setIsFormValid(false);
		setAttributes(attrs);
	}, [attrs]);

	const handlePressBrowseFile = async (datatype_label) => {
		let file = await DocumentPicker.getDocumentAsync({
			type: ["image/jpeg", "application/pdf", "image/png"],
		});

		if (Platform.OS !== "web") {
			let fileBase64 = await FileSystem.readAsStringAsync(file.uri, {
				encoding: "base64",
			});

			file = { ...file, uri: await fileBase64, type: file.mimeType };

			setUserDetails({ ...UserDetails, [datatype_label]: file });
			InfoToast("Your file has been attached");
		} else {
			setUserDetails({ ...UserDetails, [datatype_label]: file });
			InfoToast("Your file has been attached");
		}
	};

	const onCapture = async (photo) => {
		let date = new Date().toISOString().substring(0, 10).split("-").join("");
		let time = new Date().toISOString().substring(11, 19).split(":").join("");
		let img = {
			...photo,
			mimeType: "image/jpeg",
			name: `IMG_${date}_${time}.jpg`,
		};

		let fileBase64 = await FileSystem.readAsStringAsync(img.uri, {
			encoding: "base64",
		});

		img = { ...img, uri: await fileBase64, type: img.mimeType };

		setUserDetails({
			...UserDetails,
			"ID/Passport Document": img,
		});
		onClose();
	};

	const checkIfAccountExist = async () => {
		try {
			let accountStatus = await checkAccountExists(
				UserDetails["Cellphone Number"]
			);

			if (accountStatus.data.storemember_guid) {
				ErrorToast(
					"The Cellphone Number is linked to an existing account",
					"Register Member"
				);
				setIsSubmitting(false);
				return true;
			}

			return false;
		} catch (error) {
			return false;
		}
	};

	const registerUser = async () => {
		try {
			setIsSubmitting(true);

			if ((await checkIfAccountExist()) === true) return;

			let user = await registerAccount(UserDetails["Cellphone Number"]);

			let profile = await profileSetup(user.data.storemember_guid, UserDetails);

			let documents = await attachFiles(
				user.data.storemember_guid,
				UserDetails
			);

			if (user?.data.result && profile?.data.result && documents?.data.result) {
				SuccessToast(
					"Your registration was successfully submitted and your account will be moderated and verified before activation, you will receive a SMS once your account is activated",
					"Member registration"
				);
				setIsSubmitting(false);
				navigation.navigate("Home");
			}
		} catch (error) {
			setIsSubmitting(false);
			console.log("registerUser => ", error);
			if (error.data?.error) {
				ErrorToast(error.data.error, "Register Member");
			} else {
				ErrorToast(error.message, "Register Member");
			}
		}
	};

	return (
		<>
			{Attributes.length <= 0 ? (
				<LoadingIndicator />
			) : (
				<View style={{ flex: 1 }}>
					<FormControl isRequired>
						<Stack mx="3" space={2.5}>
							<HeaderText>Personal Info</HeaderText>
							{Attributes?.map((control, index) => {
								switch (control.componenttype_name) {
									case "INPUT":
										if (
											control?.sitepagecomponent_meta?.options &&
											control?.sitepagecomponent_meta?.options?.length > 0
										) {
											return (
												<View key={control.sitepagecomponent_guid}>
													<View>
														{control.datatype_label === "Store" &&
															showFilter && (
																<View
																	style={{
																		flexDirection: "row",
																		justifyContent: "space-around",
																		flexWrap: "wrap",
																		marginVertical: 5,
																	}}
																>
																	<View>
																		<FormControl.Label>{`Filter by Province`}</FormControl.Label>
																		<Select
																			// minWidth={
																			// 	control.datatype_label === "Store"
																			// 		? "70%"
																			// 		: "full"
																			// }
																			onValueChange={(value) =>
																				onRegionalChange(value)
																			}
																			name={`${control.datatype_label}`}
																			selectedValue={regional}
																			placeholder={` Select Province...`}
																		>
																			<Select.Item
																				key={index}
																				label={"All"}
																				value={""}
																			/>
																			{Object.keys(
																				control.sitepagecomponent_meta.relations
																					?.regional
																			).map((key, index) => {
																				return (
																					<Select.Item
																						key={key}
																						label={
																							control.sitepagecomponent_meta
																								.relations?.regional[key]
																						}
																						value={key}
																					/>
																				);
																			})}
																		</Select>
																	</View>
																	<View>
																		<FormControl.Label>{`Filter by Channel/Group`}</FormControl.Label>
																		<Select
																			// minWidth={
																			// 	control.datatype_label === "Store"
																			// 		? "70%"
																			// 		: "full"
																			// }
																			onValueChange={(value) =>
																				onChannelChange(value)
																			}
																			name={`${control.datatype_label}`}
																			selectedValue={channel}
																			placeholder={` Select Channel/Group...`}
																		>
																			<Select.Item
																				key={index}
																				label={"All"}
																				value={""}
																			/>
																			{Object.keys(
																				control.sitepagecomponent_meta.relations
																					?.channel
																			).map((key, index) => {
																				return (
																					<Select.Item
																						key={key}
																						label={
																							control.sitepagecomponent_meta
																								.relations?.channel[key]
																						}
																						value={key}
																					/>
																				);
																			})}
																		</Select>
																	</View>
																</View>
															)}

														<FormControl.Label>{`${control.datatype_label}`}</FormControl.Label>
														{isWeb() || control.datatype_label !== "Store" ? (
															<View>
																<View
																	style={{
																		// flexDirection: "row",
																		justifyContent: "space-between",
																	}}
																>
																	<Select
																		// style={{ flex: 1 }}
																		minWidth={"full"}
																		onValueChange={(value) =>
																			onChange(value, control.datatype_label)
																		}
																		name={`${control.datatype_label}`}
																		selectedValue={
																			UserDetails[control.datatype_label]?.value
																		}
																		placeholder={` Select ${control.datatype_label}...`}
																	>
																		{control.sitepagecomponent_meta.options
																			?.filter((value) => {
																				if (
																					control.datatype_label !== "Store"
																				) {
																					return value;
																				}

																				if (channel == "" && regional == "") {
																					return value;
																				}

																				if (
																					value.relations?.channel?.guid ==
																						channel &&
																					regional == ""
																				) {
																					return value;
																				}
																				if (
																					value.relations?.regional?.guid ==
																						regional &&
																					channel == ""
																				) {
																					return value;
																				}

																				if (
																					value.relations?.channel?.guid ==
																						channel &&
																					value.relations?.regional?.guid ==
																						regional
																				) {
																					return value;
																				}
																			})
																			.map((option, index) => {
																				if (option.value) {
																					return (
																						<Select.Item
																							key={index}
																							label={option.value}
																							value={option.key}
																						/>
																					);
																				} else {
																					return (
																						<Select.Item
																							key={index}
																							label={option}
																							value={option}
																						/>
																					);
																				}
																			})}
																	</Select>
																	{control.datatype_label === "Store" && (
																		<Button
																			colorScheme="coolGray"
																			variant="ghost"
																			onPress={() => setShowFilter(!showFilter)}
																			// style={{ flex: 1 }}
																		>
																			{showFilter
																				? "Hide Filter"
																				: "Filter stores"}
																		</Button>
																	)}
																</View>
															</View>
														) : (
															<>
																<View
																	style={{
																		// flexDirection: "row",
																		justifyContent: "space-between",
																	}}
																>
																	<View
																		style={{
																			borderColor: "#ededed",
																			borderWidth: 1,
																			borderRadius: 5,
																		}}
																	>
																		<Picker
																			// minWidth={
																			// 	control.datatype_label === "Store"
																			// 		? "70%"
																			// 		: "full"
																			// }
																			itemStyle={{ fontSize: 12 }}
																			type="dialog"
																			onValueChange={(value) =>
																				onChange(value, control.datatype_label)
																			}
																			name={`${control.datatype_label}`}
																			selectedValue={
																				UserDetails[control.datatype_label]
																					?.value
																			}
																			placeholder={` Select ${control.datatype_label}...`}
																			numberOfLines={2}
																		>
																			<Picker.Item
																				enabled={false}
																				style={{ color: "#d5d5d5" }}
																				label={`Select ${control.datatype_label}`}
																				value={""}
																			/>
																			{control.sitepagecomponent_meta.options
																				?.filter((value) => {
																					if (
																						control.datatype_label !== "Store"
																					) {
																						return value;
																					}

																					if (channel == "" && regional == "") {
																						return value;
																					}

																					if (
																						value.relations?.channel?.guid ==
																							channel &&
																						regional == ""
																					) {
																						return value;
																					}
																					if (
																						value.relations?.regional?.guid ==
																							regional &&
																						channel == ""
																					) {
																						return value;
																					}

																					if (
																						value.relations?.channel?.guid ==
																							channel &&
																						value.relations?.regional?.guid ==
																							regional
																					) {
																						return value;
																					}
																				})
																				.map((option, index) => {
																					if (option.value) {
																						return (
																							<Picker.Item
																								key={index}
																								label={option.value}
																								value={option.key}
																							/>
																						);
																					} else {
																						return (
																							<Picker.Item
																								key={index}
																								label={option}
																								value={option}
																							/>
																						);
																					}
																				})}
																		</Picker>
																	</View>
																	{control.datatype_label === "Store" && (
																		<Button
																			colorScheme="coolGray"
																			variant="ghost"
																			onPress={() => setShowFilter(!showFilter)}
																			// style={{ flex: 1 }}
																		>
																			{showFilter
																				? "Hide Filter"
																				: "Filter stores"}
																		</Button>
																	)}
																</View>
															</>
														)}
													</View>
												</View>
											);
										} else if (control.sitepagecomponent_meta.attributes) {
											if (
												control.sitepagecomponent_meta.attributes.type ===
												"file"
											) {
												return (
													<View key={control.sitepagecomponent_guid}>
														<FormControl.Label>{`${control.datatype_label}`}</FormControl.Label>
														<View
															style={{
																justifyContent: "space-around",
															}}
														>
															{isWeb() ? (
																<>
																	<Button
																		// bgColor={colors.primary}
																		style={
																			isDesktopOrLaptop[0]
																				? {
																						marginRight: "auto",
																						marginLeft: "auto",
																				  }
																				: {}
																		}
																		onPress={() =>
																			handlePressBrowseFile(
																				control.datatype_label
																			)
																		}
																		leftIcon={
																			<Icon
																				as={Ionicons}
																				name="cloud-upload-outline"
																				size="sm"
																			/>
																		}
																	>
																		Upload
																	</Button>
																	<Text color="primary.300">
																		{UserDetails[control.datatype_label]?.name}
																	</Text>
																</>
															) : (
																<Input
																	name={`${control.datatype_label}`}
																	value={
																		UserDetails[control.datatype_label]?.name
																	}
																	isReadOnly={true}
																	multiline={true}
																	numberOfLines={2}
																	type="text"
																	padding="2"
																	placeholder={control.datatype_label}
																	InputRightElement={
																		<IconButton
																			onPress={onOpen}
																			size="md"
																			_icon={{
																				as: MaterialIcons,
																				name: "camera-alt",
																				color: "primary.500",
																				size: "md",
																			}}
																		/>
																	}
																	InputLeftElement={
																		<IconButton
																			onPress={() =>
																				handlePressBrowseFile(
																					control.datatype_label
																				)
																			}
																			size="md"
																			_icon={{
																				as: MaterialIcons,
																				name: "photo",
																				color: "primary.500",
																				size: "md",
																			}}
																		/>
																	}
																/>
															)}
														</View>
													</View>
												);
											}
										} else {
											let controlType = "text";
											let showPasswordBar = false;
											let showHelper = false;
											if (
												control.datatype_label
													.toLowerCase()
													.includes("cellphone")
											) {
												showHelper = true;
											}
											if (
												control.datatype_label.toLowerCase().includes("email")
											) {
												controlType = "email";
											} else if (
												control.datatype_label
													.toLowerCase()
													.includes("password")
											) {
												controlType = "password";

												if (control.datatype_label === "Password")
													showPasswordBar = true;
											}

											return (
												<View key={control.sitepagecomponent_guid}>
													<FormControl.Label>{`${control.datatype_label}`}</FormControl.Label>
													<Input
														onChangeText={(value) =>
															onChange(value, control.datatype_label)
														}
														secureTextEntry={
															controlType == "password" ? true : false
														}
														placeholder={`${control.datatype_label}`}
														label={`${control.datatype_label}`}
														name={`${control.datatype_label}`}
														value={UserDetails[control.datatype_label]}
													/>
													{showHelper && (
														<FormControl.HelperText _text={{ fontSize: "xs" }}>
															{control.sitepagecomponent_meta.input_notice}
														</FormControl.HelperText>
													)}
													{showPasswordBar && (
														<BarPasswordStrengthDisplay
															password={
																UserDetails[control.datatype_label] || ""
															}
															width={
																isDesktopOrLaptop[0] ? width / 1.6 : width / 1.4
															}
															passwordProps={{
																minLength: 3,
															}}
														/>
													)}
												</View>
											);
										}

									default:
										break;
								}
							})}
							<AlertDialog
								Validate={Validate}
								registerUser={registerUser}
								isSubmitting={isSubmitting}
							>
								<Summary User={UserDetails} />
							</AlertDialog>
						</Stack>
					</FormControl>
					<Actionsheet isOpen={isOpen} onClose={onClose}>
						<Actionsheet.Content style={{ height: height / 1.3 }}>
							<AppCamera onClose={onClose} onCapture={onCapture} />
						</Actionsheet.Content>
					</Actionsheet>
				</View>
			)}
		</>
	);
};

export default MemberRegistration;
